import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

/**
 * Validateur d'email avec un pattern plus strict que Validators.email par défaut.
 * Le pattern exige la présence d'un top-level domain (ex: .com, .fr).
 * @returns {ValidatorFn}
 */
export function emailValidator(): ValidatorFn {
    // Cette regex est une version légèrement plus stricte et couramment utilisée.
    // Elle est pensée pour capturer la plupart des formats d'email valides
    // et rejeter ceux qui n'ont pas de TLD ou une structure de domaine invalide.
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return (control: AbstractControl): ValidationErrors | null => {
        if (Validators.required(control)) {
            // Laisse Validators.required gérer les champs vides
            return null; // Si le champ est vide et "required" n'est pas appliqué, passe la validation
        }

        // Applique le pattern regex
        const isValid = emailRegex.test(control.value);

        // Retourne l'erreur 'invalidEmailPattern' si la validation échoue
        return isValid ? null : { invalidEmailPattern: true };
    };
}
